import React from 'react';
import { Typography, Box } from 'vindi-ds-components';

function ChargesPendingEmptyHeadline() {
  return (
    <Box display='flex' flexDirection='column' sx={{ gap: '8px' }}>
      <Typography variant='subtitle1'>Nenhuma cobrança encontrada</Typography>
      <Typography variant='body2'>
        Quando existirem cobranças pendentes, elas aparecerão aqui.
      </Typography>
    </Box>
  );
}

export default ChargesPendingEmptyHeadline;
